module.exports = __webpack_public_path__ + "img/i_c_document_g.589af121.svg";